import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
// import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const RegistrationPub = () => {
  return (
    <React.Fragment>
      <SEO title="Public Registration | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Public Registration"
        content="For Authors"
        contentTwo="Public Registration"
        linkage="/registration_pub"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <h3>Public Registration</h3>
        <br />
        <br />
        <br />
        <h5>Please follow the two steps below to complete registration!</h5>
        <br />
        <br />
        <br />

        <div className="entry-content2">
          <table>
            <tr>
              <td>
                <h5>Step 1.</h5>
              </td>
              <td>
                <div className="double-reg">
                  <Link
                    className="btn btn-primary btn-hover-secondary  mt-s"
                    to={process.env.PUBLIC_URL + "/paych_pub"}
                  >
                    Pay Registration Fee (RMB payment)
                  </Link>
                  <div className="space2">
                    <p>OR</p>
                  </div>
                  <Link
                    className="btn btn-primary btn-hover-secondary  mt-s"
                    to={process.env.PUBLIC_URL + "/pay_pub"}
                  >
                    Pay Registration Fee (non-RMB payment)
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <h5>Step 2.</h5>
              </td>
              <td>
                <Link
                  className="btn btn-primary btn-hover-secondary mt-s"
                  to={process.env.PUBLIC_URL + "/form_pub"}
                >
                  Fill Online Registration Form
                </Link>
              </td>
            </tr>
            {/* <tr>
										<td >
											<h5>Step 3.</h5>
										</td>
										<td>
                                        <Link className="btn btn-primary btn-hover-secondary mt-s" to={process.env.PUBLIC_URL + "/upload"}>Prepare camera-ready paper and upload them via your Easychair account</Link>
										</td>
									</tr> */}
          </table>
          <br />
          <h3 className="note">Note</h3>
          <br />
          <p>
            <span className="lm">Registration Deadline: July 15th, 2022</span>
          </p>
          {/* <p>2. With the progress of global mass vaccination and considering the good epidemic situation in China, we have great confidence to hold the ICSI&apos; 2022 normally, so you are encouraged to attend our event to give oral presentations and communication onsite. However, there is still able to provide an opportunity of online presentation for those who are unable to join us onsite according to prevention policy.</p> */}
          {/* <p>3. CANCELLATION &amp; REFUND Policy: All cancellations must be sent in writing to the
									conference secretariat. Your payment minus 15% of total amount of registration fee
									for administrative costs will be refunded if your cancellation notice is received
									before April 30, 2022, otherwise no refund will be made after the registration
									deadline.</p> */}
        </div>
        <div className="space-120"></div>
        <div className="author reg">
          <h5>
            If you are an author of ICSI &apos;2022 and would like to view
            previous registration pages, please visit the Link below.
          </h5>
          <Link
            className="btn btn-primary btn-hover-secondary  mt-s"
            to={process.env.PUBLIC_URL + "/registration"}
          >
            Author Registration
          </Link>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default RegistrationPub;
